/***
 * This will take a time string as hh:mm:ss and format it.
 * If hours are 0, it should strip it off. If hours are 0 and 
 * minutes are less than 10, strip leading 0. If hours and minutes
 * are 0, only show 1 '0' for minutes.
 * 
 * If a null or a number is passed in, just returning an empty string.
 * 
 * If another string is passed in, not in the right format, just returning it.
 * */ 

const formatTime = (t) => {
  // If null or a number passed in, return empty string.
  if (typeof t !== 'string') { 
    return '';
  }
  
  // If another string in, not in hh:mm:ss format, just return it.
  if (!t.match(/^\d{2}:\d{2}:\d{2}$/)) {
    return t;
  }
  return t.split(':').reduce((acc, currVal, currIndex) => {
    let newVal = currVal;
    if (currIndex === 0) {
      if (currVal === '00') return '';
        return `${parseInt(currVal)}:`;
    }
    if (currIndex === 1) {
      if (acc !== '') {
        newVal = `${currVal}:`;
      } else {
        newVal = `${parseInt(currVal)}:`;
      }
    }
    return acc + newVal;
  }, '');
};

export default formatTime;